import React from "react";
import { Link } from "react-router-dom";
function TeamMembers() {
  return (
    <div>
      <section className="lawyers-team-section style-three">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 align-items-end">
            <div className="col-12 col-sm-6">
              {/* Section Heading */}
              <div className="section-heading">
                <div className="sub-title text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Attorney
                </div>
                <h2 className="mb-0 text-white">
                  Meet the Legal Experts Behind Your Success
                </h2>
              </div>
            </div>

            <div className="col-12 col-sm-6">
              <div className="text-sm-end">
                {/* Button */}
                <Link
                  className="btn btn-primary wow fadeInUp"
                  to="/team"
                  data-wow-duration="1000ms"
                  data-wow-delay="700ms"
                >
                  <span>
                    View All Attorneys <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    View All Attorneys <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="divider-sm"></div>

        <div className="container">
          <div className="row g-4">
            {/* Laywer Card */}
            <div className="col-12 col-sm-6 col-lg-4">
              <div className="laywer-card style-two">
                <img src="assets/img/bg-img/70.jpg" alt="" />

                {/* Laywer Info */}
                <div className="laywer-info d-flex align-items-center justify-content-between gap-3">
                  <div>
                    <div className="laywer-name text-white">
                      Rebecca Edwards
                    </div>
                    <div className="laywer-position text-white">
                      Senior Consultant
                    </div>
                  </div>

                  <button className="social-nav-trigger">
                    <i className="ti ti-share"></i>
                    <i className="ti ti-x"></i>
                  </button>
                </div>

                {/* Social Nav */}
                <div className="social-nav lawyer-social-nav">
                  <Link to="#">
                    <i className="ti ti-brand-facebook"></i>
                  </Link>
                  <Link to="#">
                    <i className="ti ti-brand-x"></i>
                  </Link>
                  <Link to="#">
                    <i className="ti ti-brand-linkedin"></i>
                  </Link>
                  <Link to="#">
                    <i className="ti ti-brand-instagram"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* Laywer Card */}
            <div className="col-12 col-sm-6 col-lg-4">
              <div className="laywer-card style-two">
                <img src="assets/img/bg-img/71.jpg" alt="" />

                {/* Laywer Info */}
                <div className="laywer-info d-flex align-items-center justify-content-between gap-3">
                  <div>
                    <div className="laywer-name text-white">
                      Rebecca Edwards
                    </div>
                    <div className="laywer-position text-white">
                      Senior Consultant
                    </div>
                  </div>

                  <button className="social-nav-trigger">
                    <i className="ti ti-share"></i>
                    <i className="ti ti-x"></i>
                  </button>
                </div>

                {/* Social Nav */}
                <div className="social-nav lawyer-social-nav">
                  <Link to="#">
                    <i className="ti ti-brand-facebook"></i>
                  </Link>
                  <Link to="#">
                    <i className="ti ti-brand-x"></i>
                  </Link>
                  <Link to="#">
                    <i className="ti ti-brand-linkedin"></i>
                  </Link>
                  <Link to="#">
                    <i className="ti ti-brand-instagram"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* Laywer Card */}
            <div className="col-12 col-sm-6 col-lg-4">
              <div className="laywer-card style-two">
                <img src="assets/img/bg-img/72.jpg" alt="" />

                {/* Laywer Info */}
                <div className="laywer-info d-flex align-items-center justify-content-between gap-3">
                  <div>
                    <div className="laywer-name text-white">
                      Rebecca Edwards
                    </div>
                    <div className="laywer-position text-white">
                      Senior Consultant
                    </div>
                  </div>

                  <button className="social-nav-trigger">
                    <i className="ti ti-share"></i>
                    <i className="ti ti-x"></i>
                  </button>
                </div>

                {/* Social Nav */}
                <div className="social-nav lawyer-social-nav">
                  <Link to="#">
                    <i className="ti ti-brand-facebook"></i>
                  </Link>
                  <Link to="#">
                    <i className="ti ti-brand-x"></i>
                  </Link>
                  <Link to="#">
                    <i className="ti ti-brand-linkedin"></i>
                  </Link>
                  <Link to="#">
                    <i className="ti ti-brand-instagram"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default TeamMembers;
